import loadScript from 'load-script';
//import {facebook_app_id} from '../../../config';
export default function messenger(facebook_app_id,callback) {
  window.fbAsyncInit = () => {
    window.FB.init({
      appId            : facebook_app_id,
      autoLogAppEvents : true,
      xfbml            : true,
      version          : 'v3.3'
    });
  };
  loadScript(`https://connect.facebook.net/vi_VN/sdk/xfbml.customerchat.js`, { async: true },(err)=>{
    if(err) return console.log("Can't load facebook SDK");
    callback(window.FB);
  });
}
